/**
 * Human-friendly relative time string — "just now", "12m ago",
 * "3h ago", "5d ago", then falls back to a locale date. Used by
 * layout cards, home widgets, and anywhere else we surface
 * a last-modified hint.
 */
export function timeAgo(dateStr: string | undefined | null): string {
  if (!dateStr) return ''
  const parsed = new Date(dateStr)
  const ts = parsed.getTime()
  if (Number.isNaN(ts)) return ''
  const seconds = Math.floor((Date.now() - ts) / 1000)
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}d ago`
  return parsed.toLocaleDateString()
}
